import React, { Component } from "react"
import PropTypes from "prop-types"
import _omit from "lodash/omit"

export class Element extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    element: PropTypes.object,
    defaults: PropTypes.object,
    onClick: PropTypes.func,
    onChange: PropTypes.func
  }

  handleChange = element => {
    this.props.onChange(element)
  }

  handleClick = () => {
    this.props.onClick(this.props.element.name)
  }

  render() {
    const className =
      this.props.className || "formkit-" + this.props.element.name

    return React.cloneElement(this.props.children, {
      onChange: this.handleChange,
      onClick: this.handleClick,
      className,
      ..._omit(this.props.element, "props"),
      ...this.props.children.props
    })
  }
}
